import * as React from "react";
import {DynamicDialog, DynamicDialogProps, DynamicDialogState} from "shared/controls/Dialogs/core/DynamicDialog";
import {DialogProps} from "shared/controls/Dialogs/core/Dialog";
import {ReactNode} from "react";
import {DocumentManager} from "../Manager/PDFManager/DocumentManager";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {DocumentManagerOptions} from "../Manager/PDFManager/DocumentManager.Options";
import {Tabs} from "shared/controls/Tabs/Tabs";
import {SelectAPDF} from "../Controls/SelectAPDF";
import {ToastService} from "shared/core/services/ToastService";
import {faTimes} from "@fortawesome/free-solid-svg-icons/faTimes";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {SpinnerButton} from "shared/controls/SpinnerButton";
import {faUpload} from "@fortawesome/free-solid-svg-icons/faUpload";
import {WpAjaxPost} from "shared/core/ajax/WPAjaxPost";
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";
import './FontDialog.css';

export class FontDialog extends DynamicDialog<WelcomeDialogProps, FontDragControlState> {
    static defaultProps: Partial<WelcomeDialogProps> = {};
    private fileUploaderNode:HTMLInputElement;
    public File:any=null;
    public UploadIsBusy:boolean=false;
    public IsBusyRemoveFonts:string[]=[];
    constructor(props: WelcomeDialogProps) {
        super(props);
        this.state = {
            IsOpen: true,
            IsBusy: false,
            IsUploading:false,
            FileToUpload:'',
            IsDragging:false
        };
    }

    GetAdditionalProperties(): DialogProps {
        return {
            Title:"Font Management",
            EnableCancel:false,
            EnableApply:true,
            OnClose:()=> {


            },
            ApplyTitle:'Done',
            OnApply:()=>{
                this.SendResult(true);
            }
        };
    }

    SubRenderer(): ReactNode {
        return (
            <div>

                <fieldset style={{border:'1px solid #ccc',borderRadius:5,marginTop:10}}>
                    <legend style={{marginLeft:5}}>Installed Fonts</legend>
                    <div className={'FontList'}>
                        {(rnImporterVar as any).Fonts.map(x=><div className={'fontItem'}>{x} <SpinnerButton IsBusy={this.IsBusyRemoveFonts.includes(x)} OnClick={()=>this.RemoveFont(x)} Icon={faTrash}>Remove</SpinnerButton></div>)}
                    </div>
                </fieldset>

                <fieldset style={{border:'1px solid #ccc',borderRadius:5,padding:10}}>
                    <legend>New Font</legend>
                    <div style={{textAlign:'center'}}>
                        <div className={'fontDragControl'} style={{display:'inline-block'}}>
                            <input onChange={e=>this.OnDrop((this.fileUploaderNode as any).files)} accept={'.ttf'} type={'file'} ref={e=>this.fileUploaderNode=e} style={{display:'none',margin:'auto'}}/>
                            <div onClick={() => this.fileUploaderNode.click()} onDragOver={e => e.preventDefault()}
                                 onDrop={e => {
                                     e.preventDefault();
                                     this.OnDrop(e.dataTransfer.files)
                                 }} onDragEnter={(e) => this.OnDragEnter(e)} onDragLeave={(e) => this.OnDragLeave()}
                              style={{position:'relative', cursor: 'pointer', width: 150, height: 150, border: '1px solid #dfdfdf', margin: 'auto', display: 'flex', alignItems: 'center', fontSize: 16, padding: 10, borderColor: this.state.IsDragging ? 'red' : '#dfdfdf'}}>

                                {this.File!=null&&<span onClick={(e:any)=>{e.stopPropagation()}}><FontAwesomeIcon icon={faTimes} style={{position:'absolute',top:1,right:1}} /></span>}
                                <div style={{pointerEvents:'none'}}>

                                    <label style={{position:"absolute",top:1,left:1,opacity:.7}}>New Font</label>
                                    <p style={{fontSize: 16,textAlign:'center',width:'100%',wordBreak:'break-all'}}>{this.File==null?"Drag or click here to upload a font file (*.ttf) here":this.File.name}</p>
                                </div>
                            </div>

                            {this.File!=null&&
                                <div style={{marginTop:20}}>
                                    <SpinnerButton IsBusy={this.UploadIsBusy} OnClick={()=>this.Upload()} Icon={faUpload}>Upload</SpinnerButton>
                                </div>
                            }

                        </div>
                    </div>
                </fieldset>
            </div>
        )
    }


    private async OnDrop(files: FileList) {
        if(files.length>1) {
            ToastService.SendErrorMessage('Please upload one file at a time');
            return;
        }

        if(files.length>0&&!files[0].name.toLowerCase().endsWith('.ttf'))
        {
            ToastService.SendErrorMessage("Only .ttf files can be uploaded");
            return;
        }

        this.File=files.length==0?null:files.item(0);
        debugger;
        this.forceUpdate();
//		this.setState({IsUploading:true,IsDragging:false,FileToUpload:files[0].name.substring(0,files[0].name.length)});
        /*let result=await WpAjaxPost.Post('rednao_wcpdfinv_upload_font',{},{Nonce:rednaoPDFInvoiceParams.FontNonce},{Font:files[0]});
        this.setState({IsUploading:false});
        this.fileUploaderNode.value='';

        if(result!=null) {
            rednaoPDFInvoiceParams.AvailableFonts.push(result);
            this.SendResult(result);

            let css:HTMLStyleElement=document.createElement('style');
            css.type='text/css';
            css.appendChild(document.createTextNode(`@font-face{font-family:${result}; src:url('${rednaoPDFInvoiceParams.FontURL+result}');}`));
            document.body.appendChild(css);

            ToastService.SendSuccess("Font " + result + ' uploaded successfully');
        }
*/
    }


    private OnDragEnter(e: React.DragEvent<HTMLDivElement>) {
        e.preventDefault();
        this.setState({IsDragging:true});
    }

    private OnDragLeave() {
        this.setState({IsDragging:false});
    }


    private async Upload() {
        this.UploadIsBusy=true;
        this.forceUpdate();

        let result=await WpAjaxPost.Post('UploadFont',{},{},{Font:this.File});
        if(result!=null)
        {
            ToastService.SendSuccess("Font uploaded successfully");

            (rnImporterVar as any).Fonts.push(result);
            this.SendResult(true);
            return;
        }

        this.SendResult(false);

    }

    private async RemoveFont(x: any) {
        if(this.IsBusyRemoveFonts.includes(x))
            return;

        this.IsBusyRemoveFonts.push(x);
        this.forceUpdate();

        let result=await WpAjaxPost.Post('RemoveFont',{Font:x});
        if(result!=null)
        {
            (rnImporterVar as any).Fonts=(rnImporterVar as any).Fonts.filter(y=>y!=x);
            this.forceUpdate();
        }
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface WelcomeDialogProps extends DynamicDialogProps {
    DocumentManager:DocumentManager;
}

interface WelcomeDialogState extends DynamicDialogState {

}

interface FontDragControlState {
    IsOpen:boolean;
    IsBusy:boolean;
    IsUploading:boolean;
    IsDragging:boolean;
    FileToUpload:string;
}

//#endregion "My Region"